<div class="card highlights-card">
  <div class="card-body p-2 p-md-4 position-relative" style="min-height: 200px;">
    <h3 class="highlights-title fw-bold mb-4">Highlights</h3>

    <!-- Loading State -->
    @if (loader) {
      <div class="d-flex justify-content-center align-items-center py-5">
        <output class="spinner-border text-primary" aria-hidden="true"></output>
      </div>
    }

    <!-- Error State -->
    @if (!loader && errorMessage) {
      <div class="alert alert-danger p-3 my-3">
        {{ errorMessage }}
      </div>
    }

    <!-- Content Sections (Only show if not loading and no error) -->
    @if (!loader && !errorMessage) {
      <!-- Key Metrics -->
      <div class="metrics-section mb-2">
        <h6 class="section-label mb-2">Key metrics</h6>
        <div class="row g-2">
          <div class="col-6">
            <div class="mini-card">
              <span class="card-label">Top dealer</span>
              <span class="card-value fw-bold">{{highlights.keyMetrics?.topBuyer || '-'}}</span>
            </div>
          </div>
          <div class="col-6">
            <div class="mini-card">
              <span class="card-label d-block">Quantity sold</span>
              <span class="card-value fw-bold">{{highlights.keyMetrics?.itemsSold || '-'}}</span>
            </div>
          </div>
          <div class="col-6">
            <div class="mini-card">
              <span class="card-label d-block">Most sold at</span>
              <span class="card-value fw-bold">{{highlights.keyMetrics?.mostSoldAt || '-'}}</span>
            </div>
          </div>
          <div class="col-6">
            <div class="mini-card">
              <span class="card-label d-block">Avg sale price (Dealer)</span>
              <span class="card-value fw-bold">₹{{highlights.keyMetrics?.avgPrice | number}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Last Sale -->
      <div class="metrics-section mb-2">
        <h6 class="section-label mb-2">Last sale</h6>
        <div class="row g-2">
          <div class="col-4">
            <div class="mini-card">
              <span class="card-label d-block">Date</span>
              <span class="card-value fw-bold">{{highlights.lastSale?.date}}</span>
            </div>
          </div>
          <div class="col-4">
            <div class="mini-card">
              <span class="card-label d-block">Price</span>
              <span class="card-value fw-bold">₹{{highlights.lastSale?.price | number}}</span>
            </div>
          </div>
          <div class="col-4">
            <div class="mini-card">
              <span class="card-label d-block">Qty</span>
              <span class="card-value fw-bold">{{highlights.lastSale?.quantity}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Alert (Conditional, hardcoded for now as per design) -->
      @if (highlights.notMovedIn >= 30) {
        <div [ngClass]="highlights.notMovedIn >= 60 ? 'alert-custom' : 'alert-custom-medium' "
          class="mb-2 d-flex align-items-center">
          <fa-icon [icon]="faExclamationTriangle"></fa-icon>
          <span class="alert-text ms-1 fw-bold">{{highlights.notMovedMsg}}</span>
        </div>
      }
      <!-- Price Trend -->
      <div class="metrics-section mb-2">
        <h6 class="section-label mb-2">Price trend (Customer)</h6>
        <div class="row g-2">
          <div class="col-4">
            <div class="mini-card">
              <span class="card-label d-block">Lowest</span>
              <span class="card-value fw-bold text-danger">₹{{highlights.priceTrend?.lowest | number}}</span>
            </div>
          </div>
          <div class="col-4">
            <div class="mini-card">
              <span class="card-label d-block text-muted">Average</span>
              <span class="card-value fw-bold">₹{{highlights.priceTrend?.average | number}}</span>
            </div>
          </div>
          <div class="col-4">
            <div class="mini-card">
              <span class="card-label d-block text-muted">Highest</span>
              <span class="card-value fw-bold text-success">₹{{highlights.priceTrend?.highest | number}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Avg Moment -->
      <div class="metrics-section">
        <span class="section-label mb-2">{{displayMoment}}</span>
        <div class="row g-2">
          <div class="col-6">
            <div class="mini-card">
              <span class="card-label d-block">Inwards</span>
              <span class="card-value fw-bold">{{highlights.avg?.avgInwards | number}}</span>
            </div>
          </div>
          <div class="col-6">
            <div class="mini-card">
              <span class="card-label d-block">Outwards</span>
              <span class="card-value fw-bold">{{highlights.avg?.avgOutwards | number}}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>

